import { Button } from '@radix-ui/themes';
import type { MenuItem } from '../lib/menu';

/**
 * Codex's numbered choices, as buttons you can actually hit with a thumb.
 *
 * Purely additive: the arrows and Enter still work, and if the detector finds
 * nothing this renders nothing. It is allowed to be wrong — never to be in the way.
 */
export function MenuButtons({ items, onPick }: { items: MenuItem[]; onPick: (digit: string) => void }) {
  if (!items.length) return null;

  return (
    <div className="keybar" style={{ background: 'var(--app-secondary-bg)', paddingTop: 8 }}>
      {items.map((it) => (
        <Button
          key={it.digit}
          size="2"
          variant={it.selected ? 'solid' : 'soft'}
          color={it.selected ? 'jade' : 'gray'}
          onClick={() => onPick(it.digit)}
        >
          <span style={{ opacity: 0.6 }}>{it.digit}</span>
          <span style={{ maxWidth: 190, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {it.label}
          </span>
        </Button>
      ))}
    </div>
  );
}
